<script setup lang="ts">
  import { KsButton } from '@aschehoug/kloss'
  import { useAppRouting } from '@/composables/useAppRouting'

  withDefaults(defineProps<{
    isWithBackground: boolean
  }>(), {
    isWithBackground: false
  })

  const { getParentRoute } = useAppRouting()
  const parentRoute = getParentRoute()
</script>

<template>
  <header :class="['focus-header', { 'with-background': isWithBackground}]">
    <slot />
    <router-link
      v-if="parentRoute"
      :to="parentRoute"
      class="link"
      aria-label="Tilbake"
    >
      <KsButton
        tabindex="-1"
        class="exit-button"
        shape="round"
        icon-left="xmark"
        variant="tertiary"
      />
    </router-link>
  </header>
</template>

<style scoped lang="scss">
  .focus-header {
    display: flex;
    justify-content: flex-end;
    position: fixed;
    top: 0;
    right: 0;
    padding: 16px 32px;
    width: 100%;
    z-index: 9;

    @include vgs-media-mobile-and-tablet {
      color: var(--color-red-40);
      padding: 8px 24px;

      &.with-background {
        background-color: var(--app-theme-background-color);
        box-shadow: 0 4px 3px 0 #00000040;

        .link {
          position: fixed;
        }
      }

      .ks-button {
        background-color: var(--color-yellow-10);
        margin-right: auto;
      }
    }

  }

  .exit-button {
    background-color: var(--color-pair-background-color, var(--color-yellow-10));
    border: 2px solid var(--color-pair-color, var(--color-blue-50));
    margin-left: auto;

    @include vgs-media-hover {
      background-color: var(--color-pair-hover-background-color, var(--app-theme-background-color));
    }
  }

  .link {
    @include visible-focus-ring;

    border-radius: 50%;
  }
</style>
